export const AGENT = {
  name: "Jacqueline Kane",
  firstName: "Jacqueline",
  business: "Coverage with Jacqueline",
  logoTop: "Coverage with Jacqueline",
  logoBottom: "Jacqueline Kane | Licensed Health Insurance Agent",
  role: "Independent ACA Health Insurance Agent",
  phone: "(202) 413-2343",
  phoneHref: "tel:+12024132343",
  email: "info@coveragewithjacqueline.com",
  location: "Licensed in Maryland",
  license: "Licensed Health Insurance Agent · NPN #22261975",
};

export const IMAGES = {
  heroPortrait: "/images/jacqueline-portrait.webp?v=2",
  aboutConsulting: "https://images.unsplash.com/photo-1761839258568-fd466a93f68b?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  family: "https://images.pexels.com/photos/27177631/pexels-photo-27177631.jpeg",
  familyGrass: "https://images.pexels.com/photos/5402587/pexels-photo-5402587.jpeg",
};

export const SERVICES = [
  {
    num: "01",
    title: "ACA Plans",
    desc: "Explore Maryland ACA Marketplace health insurance options for individuals and families. Get personalized guidance on plan benefits, potential financial assistance, and enrollment.",
    tag: "Individual & Family",
    guide: "aca-open-enrollment-explained",
  },
  {
    num: "03",
    title: "Dental & Vision",
    desc: "Affordable standalone coverage for the everyday visits your health plan usually leaves out.",
    tag: "Ancillary Coverage",
    guide: "dental-vision-life-worth-it",
  },
  {
    num: "04",
    title: "Supplemental Plans",
    desc: "Accident, hospital and critical illness policies that fill the gaps and cushion the surprises.",
    tag: "Extra Peace of Mind",
    guide: "hospital-indemnity-explained",
  },
];

export const CHAPTERS = [
  {
    num: "Ch. 01",
    title: "I work for you, never the carrier",
    body: "As an independent agent I represent you, not a single insurance company. That means I can compare every plan on the table and recommend only what genuinely fits your life.",
  },
  {
    num: "Ch. 02",
    title: "Plain language, zero pressure",
    body: "Insurance is confusing on purpose. My job is to translate the fine print into everyday words, answer every question, and let you decide on your own timeline.",
  },
  {
    num: "Ch. 03",
    title: "Here long after you enroll",
    body: "The relationship does not end at enrollment. When a claim gets tricky or your needs change, you call me directly, a real person who already knows your story.",
  },
];

export const TESTIMONIALS = [
  {
    quote: "I thought I couldn't afford coverage. She found me a Marketplace plan with a subsidy I had no idea existed. Truly life changing.",
    name: "Marcus T.",
    detail: "ACA / Family Plan",
  },
  {
    quote: "Finally an agent who picks up the phone. When my claim got denied she handled it for me. I recommend her to everyone I know.",
    name: "Angela R.",
    detail: "ACA + Dental",
  },
];

export const FAQS = [
  {
    q: "How much do your services cost me?",
    a: "Nothing. As a licensed independent agent I'm compensated by the insurance carriers, so my guidance, plan comparisons and ongoing support are completely free to you.",
  },
  {
    q: "When can I enroll in an ACA Marketplace plan?",
    a: "Open Enrollment runs each fall, but a qualifying life event such as moving, marriage, a new baby, or losing other coverage can open a Special Enrollment Period any time of year. Let's check if you qualify.",
  },
  {
    q: "Will you help after I enroll?",
    a: "Absolutely. Billing questions, claim issues, annual reviews: you call me directly, all year long. That continuity is the whole point of working with an independent agent.",
  },
];
